const Analysis = () => import('app/components/Analysis');
const AnalysisFilters = () => import('app/components/AnalysisFilters');
const AnalysisFormField = () => import('app/components/AnalysisFormField');
const AnalysisInputField = () => import('app/components/AnalysisInputField');
const AnalysisType = () => import('app/components/AnalysisType');
const AnalysisTypeFilters = () => import('app/components/AnalysisTypeFilters');
const ContextManager = () => import('app/components/ContextManager');
const CrAnalysis = () => import('app/components/CrAnalysis');
const CrAnalysisFilters = () => import('app/components/CrAnalysisFilters');
const CrifAnalysis = () => import('app/components/CrifAnalysis');
const CrifAnalysisFilters = () => import('app/components/CrifAnalysisFilters');
const CustomTableReport = () => import('app/components/CustomTableReport');
const Report = () => import('app/components/Report');
const ReportFilters = () => import('app/components/ReportFilters');
const ReportFormField = () => import('app/components/ReportFormField');
const ReportInputField = () => import('app/components/ReportInputField');
const Role = () => import('app/components/Role');
const RoleFilters = () => import('app/components/RoleFilters');
const RoleFormField = () => import('app/components/RoleFormField');
const RoleInputField = () => import('app/components/RoleInputField');
const TagEditor = () => import('app/components/TagEditor');
const TagFilters = () => import('app/components/TagFilters');
const TagFormField = () => import('app/components/TagFormField');
const TagInputField = () => import('app/components/TagInputField');
const TaxonomyFormField = () => import('app/components/TaxonomyFormField');
const User = () => import('app/components/User');
const UserFilters = () => import('app/components/UserFilters');
const UserFormField = () => import('app/components/UserFormField');
const UserInputField = () => import('app/components/UserInputField');
const Workgroup = () => import('app/components/Workgroup');
const WorkgroupFilters = () => import('app/components/WorkgroupFilters');
const WorkgroupFormField = () => import('app/components/WorkgroupFormField');
const WorkgroupInputField = () => import('app/components/WorkgroupInputField');
const XbrlAnalysis = () => import('app/components/XbrlAnalysis');
const XbrlAnalysisFilters = () => import('app/components/XbrlAnalysisFilters');

const DefaultHeaderDropdownAccnt = () => import('app/ui/DefaultHeaderDropdownAccnt');

export default {
  Analysis,
  AnalysisFilters,
  AnalysisFormField,
  AnalysisInputField,
  AnalysisType,
  AnalysisTypeFilters,
  ContextManager,
  CrAnalysis,
  CrAnalysisFilters,
  CrifAnalysis,
  CrifAnalysisFilters,
  CustomTableReport,
  Report,
  ReportFilters,
  ReportFormField,
  ReportInputField,
  Role,
  RoleFilters,
  RoleFormField,
  RoleInputField,
  TagEditor,
  TagFilters,
  TagFormField,
  TagInputField,
  TaxonomyFormField,
  User,
  UserFilters,
  UserFormField,
  UserInputField,
  Workgroup,
  WorkgroupFilters,
  WorkgroupFormField,
  WorkgroupInputField,
  XbrlAnalysis,
  XbrlAnalysisFilters,

  DefaultHeaderDropdownAccnt,
}
